'use client'

import { Button } from '@/components/ui/button'

/** Window event that opens the property-detail lightbox at the first photo. */
export const OPEN_GALLERY_EVENT = 'wilson:open-gallery'
/** Window event that opens the property-detail video lightbox. */
export const OPEN_VIDEO_EVENT = 'wilson:open-video'
/** Window event that opens the property-detail floorplan lightbox. */
export const OPEN_FLOORPLAN_EVENT = 'wilson:open-floorplan'

/**
 * Sidebar `Resources` pills — Figma 4022:89025 (Button size=Mini, type=outline)
 * inside `Frame 697` 4022:88916.
 *
 * `PropertyDetails` is a server component, so the buttons signal the lightboxes
 * (owned by the client `PropertyDetailPage`) through window events.
 */
export function OpenGalleryButton() {
  return (
    <Button
      type="button"
      variant="outline"
      size="mini"
      onClick={() => window.dispatchEvent(new Event(OPEN_GALLERY_EVENT))}
    >
      Gallery
    </Button>
  )
}

export function OpenVideoButton() {
  return (
    <Button
      type="button"
      variant="outline"
      size="mini"
      onClick={() => window.dispatchEvent(new Event(OPEN_VIDEO_EVENT))}
    >
      Video
    </Button>
  )
}

export function OpenFloorplanButton() {
  return (
    <Button
      type="button"
      variant="outline"
      size="mini"
      onClick={() => window.dispatchEvent(new Event(OPEN_FLOORPLAN_EVENT))}
    >
      Floorplan
    </Button>
  )
}
